import React, { Suspense } from "react";
import Container from "react-bootstrap/Container";
import { Redirect, Route, Switch } from "react-router-dom";
import { Route as AppRoute, Routes } from "./utils/Routes";
import { Footer, MainNavbar } from "./components/MainNavbar";
import { Toaster } from "react-hot-toast";
import { UserContextProvider } from "./context/UserContext";
import './App.css';


import { UserContentProvider } from './features/user-content';

function App() {
    return (
        <UserContextProvider>
            <UserContentProvider>
                <Container className="App" fluid>
                    <MainNavbar />
                    <Container fluid>
                        <Toaster />
                        <Suspense fallback={<div className="text-center py-5">Loading...</div>}>
                            <Switch>
                                {Routes.map((route, index) => (
                                    <Route key={index} path={route.route} component={route.component} exact={route.exact} />
                                ))}
                                <Route render={() => <Redirect to={AppRoute.Home} />} />
                            </Switch>
                        </Suspense>
                    </Container>
                    <Footer />
                </Container>
            </UserContentProvider>
        </UserContextProvider>
    );
}

export default App;
